/******/ (() => {
  // webpackBootstrap
  // cart remove-item loading indicator — see is-removing handling below
  var __webpack_exports__ = {};
  window.PXUTheme.jsCart = {
    init: function ($section) {
      // Add settings from schema to current object
      //window.PXUTheme.jsCart = $.extend(this, window.PXUTheme.getSectionData($section));

      this.$section = $section;

      $(document).on("click", "[data-cart-page-delete]", function (e) {
        e.preventDefault();

        // Give immediate feedback so the removal doesn't feel idle while the
        // /cart/change.js request and the cart re-render are in flight. The
        // indicator is keyed off the clicked button's own row, so it works for
        // single, grouped and bundled removals regardless of line-item keys.
        const $btn = $(this);
        if ($btn.hasClass("is-removing")) return false; // ignore repeat clicks
        const $row = $btn.closest(".item-container");
        $btn.addClass("is-removing");
        $row.addClass("is-removing");
        // Safety net: clear the indicator if the request never resolves.
        setTimeout(function () {
          $btn.removeClass("is-removing");
          $row.removeClass("is-removing");
        }, 10000);

        const lineKey = $(this).data("cart-item-key");
        if ($(this).data("cart-item-group")) window.PXUTheme.jsCart.removeByBundle(
          $(this).data("cart-item-group")
        );
        else window.PXUTheme.jsCart.removeFromCart(
          lineKey,
          $(this).data("cart-item-group")
        );

        return false;
      });

      // Prevent the ajax cart form from being submitted when pressing the "Enter" key
      $("#cart_form").keydown(function (e) {
        if (e.keyCode == 13) {
          e.preventDefault();
          return false;
        }
      });
    },
    removeByBundle: function (bundleName, cart = false) {
      if (!cart) {
        $.post('cart', x => {
          window.PXUTheme.jsCart.removeByBundle(bundleName, x);
        });
      } else {
        var id = false;
        if (cart && cart.items) for (const item of cart.items) {
          if (item?.properties?.Bundle == bundleName) {
            if (item.price > 0 && !bundleName.includes(item.product_title) && item.sku != 'card') continue;
            id = item.key;
            break;
          }
        }
        if (id) $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: { quantity: 0, id },
          dataType: "json",
          success: function (x) {
            window.PXUTheme.jsCart.removeByBundle(bundleName, x);
          },
          error: function (xhr, ajaxOptions, thrownError) {
            console.log(thrownError);
          },
        });
        else window.PXUTheme.jsCart.updateView(cart);
      }
      return true;
    },
    removeFromCart: async function (lineKey, group = false) {
      if (group) {
        const searchTxt = `[data-cart-item-group="${group}"]`;
        var cartItems = window.PXUTheme.jsCart.$section.find(searchTxt);
        var ids = [];
        cartItems;
        cartItems.each(function () {
          $(this).parents(".item-container").css("opacity", "0.5");
          ids.push($(this).data("cart-item-key"));
        });
        var cart = false;
        for (const id of ids) {
          await $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: { quantity: 0, id },
            dataType: "json",
            success: function (resp) {
              cart = resp;
            },
            error: function (xhr, ajaxOptions, thrownError) {
              console.log(thrownError);
            },
          });
        }
        window.PXUTheme.jsCart.updateView(cart);
      } else {
        const $cartItem = window.PXUTheme.jsCart.$section.find(
          `[data-line-item="${lineKey}"]`
        );
        $cartItem.css("opacity", "0.5");
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: "quantity=0&id=" + lineKey,
          // data: {},
          dataType: "json",
          success: function (cart) {
            $cartItem.addClass("animated zoomOut");
            $cartItem.remove();

            window.PXUTheme.jsCart.updateView(cart, lineKey);

            if (typeof window.PXUTheme.jsAjaxCart !== "undefined") {
              window.PXUTheme.jsAjaxCart.updateView();
            }
          },
          error: function (XMLHttpRequest, textStatus) {
            var response = eval("(" + XMLHttpRequest.responseText + ")");
            response = response.description;
          },
        });
      }
    },
    updateView: function (cart, lineKey) {
      if (cart.item_count > 0) {
        $.ajax({
          dataType: "json",
          async: false,
          cache: false,
          dataType: "html",
          url: "/cart",
          success: function (html) {
            if (lineKey !== null) {
              const updatedItems = $(html).find(".cart__item-list .cart__card");
              const currentItems = $(".cart__item-list .cart__card");

              // Checks if BOGO applied and there is a change in the number of line items
              if (updatedItems.length != currentItems.length) {
                const updatedCartList = $(html).find(".cart__item-list");
                // Re-append cart items
                $(".cart__item-list").replaceWith(updatedCartList);
              } else {
                if (false)
                  $(currentItems).each(function (index, element) {
                    $(element).attr("data-line-item", index);
                    $(element)
                      .find("[data-line-item-key]")
                      .attr("data-line-item-key", index);
                  });

                const itemTotal = $(html)
                  .find(`[data-cart-item="${lineKey}"]`)
                  .find(".cart__total");
                const quantityInput = $(html)
                  .find(`[data-cart-item="${lineKey}"]`)
                  .find(".quantity-input");
                const itemPrice = $(html)
                  .find(`[data-cart-item="${lineKey}"]`)
                  .find(".cart__price");

                $(`[data-cart-item="${lineKey}"]`)
                  .find(".cart__total")
                  .replaceWith(itemTotal);
                $(`[data-cart-item="${lineKey}"]`)
                  .find(".quantity-input")
                  .replaceWith(quantityInput);
                $(`[data-cart-item="${lineKey}"]`)
                  .find(".cart__price")
                  .replaceWith(itemPrice);
              }
            } else {
              const updatedCartList = $(html).find(".cart__item-list");
              $(".cart__item-list").replaceWith(updatedCartList);
            }

            const subtotal = $(html).find(".cart__subtotal-container");
            const discounts = $(html).find(".cart__discounts");
            const savings = $(html).find(".cart__total-savings");

            $(".cart__subtotal-container").replaceWith(subtotal);

            if (discounts.length > 0 && $(".cart__discounts").length < 1) {
              $(".cart__subtotal-container").before(discounts);
            } else {
              $(".cart__discounts").replaceWith(discounts);
            }

            if (savings.length > 0 && $(".cart__total-savings").length < 1) {
              $(".cart__subtotal-container").after(savings);
            } else {
              $(".cart__total-savings").replaceWith(savings);
            }

            $('[data-bind="itemCount"]').text(cart.item_count);
          },
        });
      } else {
        $(".cart__empty-cart-message").removeClass("is-hidden");
        $(".cart__form").addClass("is-hidden");
        $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
        $('[data-bind="itemCount"]').text("0");
      }
    },
    unload: function ($section) {
      // Clear event listeners in theme editor
      $("[data-cart-page-delete]").off();
      $("#cart_form").off();
    },
    getCart: async () => {
      const fetchCartObject = await fetch("/cart.js", {
        headers: {
          "Content-Type": "application/json",
          pragma: "no-cache",
          "cache-control": "no-cache",
        },
        credentials: "same-origin",
      });
      const responseCartObject = await fetchCartObject.json();

      return responseCartObject;
    },
  };

  /******/
})();
